import exp from "constants";

const DownloadPDF= (pdf:string,fileName:string) =>{
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    //const fileName = "file.pdf";

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

export default DownloadPDF;